<template>

    <div class="uploader" :class="classes">
        <div class="uploader-body" :style="styles">
            <input id="file" type="file" :accept="accept" @change="selectedFile($event)" />
            <div class="uploader-file">
                <span v-if="file">{{ file.name }}</span>
                <span v-else class="fs-20"><i class="fas fa-cloud-arrow-up"></i></span>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .uploader {

        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 3px;
        padding: 5px;
        transition: border-color .3s;
        &:hover {
            border-color: $color-text;
        }

        .uploader-body {
            color: $color-text;
            overflow: hidden;
            position: relative;
            input[type=file] {
                background: transparent;
                cursor: pointer;
                height: 100%;
                left: 0;
                margin: 0;
                opacity: 0;
                padding: 0;
                position: absolute;
                top: 0;
                width: 100%;
                z-index: 2;
            }
        }

        .uploader-file {
            @include font-medium(14px);
            background: $color-bg;
            display: grid;
            height: 100%;
            place-items: center;
            position: absolute;
            width: 100%;
            z-index: 1;
        }

    }

</style>

<script>

export default {

    props: {
        accept: {
            type: String,
            default: '.csv,.txt,text/plain',
        },
        height: {
            type: Number,
            default: 100,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            file: '',
        }
    },

    computed: {

        styles() {
            return {
                height: this.height + 'px',
            }
        },

        classes() {
            return {
                active: this.file,
            }
        },

    },

    methods: {

        selectedFile(e) {
            this.file = e.target.files[0];
            this.$emit('input', this.file);
        },

    }

}

</script>
